<app-modal-header title="Disable two-factor authentication" />

<form class="modal-form" (ngSubmit)="submit()" novalidate>
  <app-modal-body>
    <p class="two-factor-setup__hint">Enter a code from your authenticator app, or one of your backup codes, to turn off two-factor authentication.</p>

    <div class="form-field">
      <label class="form-field__label" for="tfa-disable-code">Code</label>
      <input
        id="tfa-disable-code"
        type="text"
        autocomplete="off"
        class="field-input field-input--text field-input--mono"
        [formControl]="code"
        placeholder="123456 or a backup code"
        data-modal-autofocus
      />
      @if (code.invalid && code.touched) {
        <p class="form-field__error">Enter a code.</p>
      }
      @if (error()) {
        <p class="form-field__error" role="alert">{{ error() }}</p>
      }
    </div>
  </app-modal-body>

  <app-modal-footer>
    <button type="button" class="btn--secondary" [disabled]="submitting()" (click)="modalRef.dismiss()">Cancel</button>
    <button type="submit" class="btn--primary btn--primary-danger" [disabled]="submitting()">
      {{ submitting() ? 'Disabling…' : 'Disable' }}
    </button>
  </app-modal-footer>
</form>
